import { IS_LOCAL } from "../constants";
export function gaModalView(path) {
    if (!IS_LOCAL) {
        const modalPath = "/modal" + path;
        window.ga?.("send", "pageview", modalPath);
    }
}
